<template lang="pug">
v-app
  v-app-bar.re-app-bar(app :height="$vuetify.breakpoint.mdAndUp ? 70 : 60")
    v-container.d-flex.align-center
      v-btn(icon @click="$router.push('/')")
        v-icon mdi-arrow-left
      v-toolbar-title {{ $t("партнеры") }}

  v-main(flat)
    v-container(style="max-width: 450px")
      v-row
        v-col.pt-1
          .subtitle-2.mt-2 {{ $t("подключайте_дополнительные_инструменты_для_развития_вашего_бизнеса") }}

      v-row
        v-col.pb-4.pt-0
          v-btn-toggle.re-partners-toggle(v-model="toggle" mandatory dense borderless)
            v-btn(disabled) {{ $t("партнеры") }}
            v-btn {{ $t("подключенные") }}

      v-row
        v-col.pt-0(:style="toggle === 1 && halykPosConnected ? 'display: block;' : 'display: none;'")
          span.re-partner-tile(@click="$router.push('/kkm/halyk/pos'); analyticsLogEvent({ eventName: 're_partner_tile_clicked', eventProperties: { tile_name: 'halykPos' } })")
            v-container.rounded-lg.re-cursor-pointer.reForeground.pa-4
              v-row
                v-col.pa-0.pl-3(cols="3")
                  v-img(eager src="/static/halyk-pos-partners.png" contain height="80px")
                v-col.py-0.px-4(cols="9")
                  div.subtitle-1.font-weight-bold {{ $t("прием_карточных_платежей_через_смартфон") }}
                  div.body-2.font-weight-medium.pt-2 {{ $t("подключается_в_ваш_смартфон_принимает_любые_карты") }}

        v-col.pt-0(:style="toggle === 1 && kaspiQRConnected ? 'display: block;' : 'display: none;'")
          span.re-partner-tile(@click="$router.push('/kkm/kaspi/qr'); analyticsLogEvent({ eventName: 're_partner_tile_clicked', eventProperties: { tile_name: 'kaspiQR' } })")
            v-container.rounded-lg.re-cursor-pointer.reForeground.pa-4
              v-row
                v-col.pa-0.pl-3(cols="3")
                  v-img(eager src="/static/kaspi-qr-partners.png" contain height="80px")
                v-col.py-0.px-4(cols="9")
                  div.subtitle-1.font-weight-bold {{ $t("KASPI_QR") }}
                  div.body-2.font-weight-medium.pt-2 {{ $t("прием_оплаты_и_фискализация_чека") }}

        v-col.pt-0(:style="toggle === 1 && moyUchetConnected ? 'display: block;' : 'display: none;'")
          span.re-partner-tile(@click="$router.push('/kkm/moyuchet'); analyticsLogEvent({ eventName: 're_partner_tile_clicked', eventProperties: { tile_name: 'moyUchet' } })")
            v-container.rounded-lg.re-cursor-pointer.reForeground.pa-4
              v-row
                v-col.pa-0.pl-3(cols="3")
                  v-img(eager src="/static/moy-uchet-partners.png" contain height="80px")
                v-col.py-0.px-4(cols="9")
                  div.subtitle-1.font-weight-bold {{ $t("онлайн_бухгалтерия_для_предпринимателей_на_упрощенке") }}
                  div.body-2.font-weight-medium.pt-2 {{ $t("рассчитывает_налоги_подтягивает_данные_из_rekassa") }}

        v-col.text-center.pt-10(v-if="toggle === 1 && !kaspiQRConnected && !halykPosConnected && !moyUchetConnected")
          v-icon(color="grey" size="110") mdi-folder-cancel-outline
          div.px-10.pt-2
            .subtitle-1.font-weight-bold {{ $t("у_вас_пока_нет_подключенных_партнеров") }}

</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale } from '../../i18n/index'

export default {
  data: () => ({
    toggle: 1,
  }),

  computed: {
    ...mapState({
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      configuration: state => state.cashRegisters.cashRegister.cashRegister.data.configuration,
    }),

    locale() {
      return getLocale()
    },

    kaspiQRConnected() {
      return this.configuration.kaspiQR && this.configuration.kaspiQR.connected
    },

    halykPosConnected() {
      return this.configuration.halyk && this.configuration.halyk.halykPosConnected
    },

    moyUchetConnected() {
      return this.configuration.moyuchet && this.configuration.moyuchet.сonnected
    },
  },

  methods: {
    ...mapActions({
      analyticsLogEvent: 'analytics/logEvent',
      showSnackbar: 'tools/showSnackbar',
    }),

  },
}
</script>

<style lang="stylus">
.re-partners-toggle
  background-color var(--v-reForeground-base) !important
  padding 8px !important
  border-radius 8px!important
  width 100%
  .v-btn
    width 50%
    height 32px!important
    background-color var(--v-reForeground-base) !important
    border-radius 8px!important
    text-transform none!important
    font-weight 500!important
    letter-spacing 0.5px!important
  .v-btn--active
    background-color var(--v-primary-base) !important
    color #fff!important
.re-partner-tile
  div
    line-height 1.2rem!important
  .subtitle-2
    font-size: 15px!important;
</style>
